const selector = {
    dynamicFieldsContainer: '#dynamicFields',
    quantity: '#quantity',
    price: '#price',
    pricePerTag: '#pricePerTag',
    pricePerTagEur: '#pricePerTagEur',
    priceField: '#priceField',
    selectedCurrency: '#selectedCurrency',
    totalTagCount: '#total_tag_count',
    totalTagPrice: '#total_tag_price',
    totalPrepaidAmount: '#total_prepaid_amount',
    deliveryPriceRow: '#delivery_price_row',
    deliveryPrice: '#delivery_price',
    totalCustomizedAmount: '#total_customized_amount',
    grandTotalPrice: '#grand_total_price',
    tagItemsContainer: '#tag_items_container',
    tagItems: '#tag_items_container .js_tag_item_container',
    btnAddTagItem: '#btn_add_tag',
    btnRemoveTagItem: '.js_remove_tag_item',
    radioBtnType: '.js_type',
    radioBtnPrepaid: '.js_type[value="pre-paid"]',
    prepaidAmount: '.js_prepaid_amount',
    customizedText: '.js_customized_text',
    prepaidAmountWrapper: '.js_prepaid_amount_wrapper',
    paymentMethod: 'input[name="payment_method"]',
    total: '#total',
    deliveryNotification: '#deliveryNotification',
    form: {
        customerType: 'input[name="customer_type"]',
        country: 'select[name="country"]',
        customerTypeChecked: 'input[name="customer_type"]:checked',
        customer: {
            cardholderName: '#first_name',
            cardholderSurname: '#last_name',
        },
        business: {
            companyName: '#company_name',
            mb: '#mb',
            pib: '#pib',
        },
    },
};

export {selector};
